<template lang="pug">
.property-info
  table.table
    thead
      tr
        th.form-label {{ $t('property.name') }}
        th.form-label {{ $t('room.layout') }}
        th.form-label {{ $t('room.area') }}
        th.form-label {{ $t('property.time_nearest_station') }}
        th.form-label {{ $t('property.building_structure') }}
        th.form-label {{ $t('property.age')}}
        th.form-label {{ $t('room.current_rent_fee')}}
        th.form-label {{ $t('competitors_page.basic_unit_price') }}
        th.form-label {{ $t('competitors_page.recommended_rent_fee') }}
        th.form-label {{ $t('competitors_page.recommentded_rent_basic_unit_price')}}
    tbody
      tr
        td {{ property.name }}
        td {{ room.layout }}
        td {{ $n(room.area) }}
        td {{ $n(property.time_nearest_station) }}
        td {{ $t(`building_structure.${property.building_structure}`) }}
        td {{ property.age }}
        td {{ $n(room.current_rent_fee) }}
        td {{ currentRentFeeBasicUnitPrice }}
        td {{ $n(recommendedRentFee, 'number') }}
        td {{ basicUnitPrice(recommendedRentFee, room.area) }}
</template>

<script>
  import recommendedFeeWithOptions from '@/mixins/recommended-fee-with-options'
  import { basicUnitPrice } from '@/helpers/property'

  export default {
    mixins: [recommendedFeeWithOptions],

    props: {
      property: {
        type: Object,
        default () {
          return {}
        }
      },
      room: {
        type: Object,
        default () {
          return {}
        }
      }
    },

    data() {
      return {
        recommendedRent: {
          deposit: { value: this.$route.params.deposit },
          keyMoney: { value: this.$route.params.keyMoney } 
        }
      }
    },

    computed: {
      currentRentFeeBasicUnitPrice() {
        if (this.property.existing) {
          return this.$n(Math.round(this.room.basic_unit_price))
        } else {
          return '–'
        }
      },

      recommendedRentFee() {
        return Math.round(this.recommendedRentWithOptions(this.room) / 100) * 100
      }
    },

    methods: { basicUnitPrice }
  }
</script>

<style lang="scss" scoped>
  .property-info {
    ::v-deep .form-label {
      color: #7c91a7;
      font-size: 13px;
      font-weight: 700;
    }

    .table {
      border: none;

      th {
        border: none;
        padding: 0 0.6rem 0 0;
      }

      td {
        border: none;
        color: #313541;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0;
        padding: 0 0.9rem 0 0;
      }
    }
  }
</style>
